import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = {
  key: 0,
  class: "loading-text"
}
const _hoisted_4 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_5 = {
  key: 2,
  class: "vacancies-list"
}
const _hoisted_6 = { class: "vacancy-image" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "vacancy-body" }
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppLayout = _resolveComponent("AppLayout")!

  return (_openBlock(), _createBlock(_component_AppLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Главная", -1)
            ]))]),
            _: 1
          }),
          _cache[1] || (_cache[1] = _createElementVNode("span", null, " → ", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "Вакансии", -1))
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "page-title" }, "Вакансии", -1)),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Загрузка..."))
          : (_ctx.vacancies.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " На данный момент открытых вакансий нет. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vacancies, (vacancy) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: vacancy.id,
                    class: "vacancy-card"
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      (vacancy.photo_url)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: vacancy.photo_url,
                            alt: vacancy.name
                          }, null, 8, _hoisted_7))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("h3", null, _toDisplayString(vacancy.name), 1),
                      (vacancy.description)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "vacancy-description",
                            innerHTML: vacancy.description
                          }, null, 8, _hoisted_9))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]))
      ])
    ]),
    _: 1
  }))
}